import React, { useState, useEffect } from 'react';
import { Container, Typography, Paper, Grid, Box } from '@mui/material';

const Help = () => {
  const [primaryColor, setPrimaryColor] = useState(localStorage.getItem('primaryColor') || '#0f0f0f');
  const [secondaryColor, setSecondaryColor] = useState(localStorage.getItem('secondaryColor') || '#1a1a1a');
  const [textColor, setTextColor] = useState(localStorage.getItem('darkMode') === 'true' ? '#ffffff' : '#000000');

  useEffect(() => {
    const checkLocalStorage = () => {
      const storedPrimary = localStorage.getItem('primaryColor');
      const storedSecondary = localStorage.getItem('secondaryColor');
      const storedDarkMode = localStorage.getItem('darkMode') === 'true';
      
      if (storedPrimary !== primaryColor) setPrimaryColor(storedPrimary);
      if (storedSecondary !== secondaryColor) setSecondaryColor(storedSecondary);
      setTextColor(storedDarkMode ? '#ffffff' : '#000000');
    };
    
    const intervalId = setInterval(checkLocalStorage, 200);
    return () => clearInterval(intervalId);
  }, [primaryColor, secondaryColor]);

  return (
    <Container maxWidth="lg" sx={{ 
      backgroundColor: `${primaryColor} !important`,
      color: textColor,
      minHeight: '100vh',
      py: 4
    }}>
      <Typography variant="h3" gutterBottom sx={{ 
        mb: 6,
        textAlign: 'center',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        color: `${textColor} !important`
      }}>
        Support Center
      </Typography>
  
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        <Paper sx={{ 
          p: 4, 
          backgroundColor: secondaryColor,
          borderRadius: 3,

        }}>
          <Typography variant="h5" gutterBottom sx={{ mb: 3, fontWeight: 'medium', color: `${textColor} !important` }}>
            Contact Information
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Typography variant="body1" sx={{ color: `${textColor} !important`}} >
              <strong>Registered Office:</strong><br />
              2/16 Aerodrome Road<br />
              Caboolture QLD 4510<br />
              Australia
            </Typography>
            <Typography variant="body1" sx={{ color: `${textColor} !important`}} >
              <strong>Customer Support:</strong><br />
              📞 (07) 5353 6011<br />
              📧 info@signblast.com.au
            </Typography>
          </Box>
        </Paper>
  
        <Paper sx={{ 
          p: 4,
          backgroundColor: secondaryColor,
          borderRadius: 3,
        }}>
          <Typography variant="h5" gutterBottom sx={{ mb: 3, fontWeight: 'medium', color: `${textColor} !important` }}>
            Operating Hours
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Typography variant="body1" sx={{ color: `${textColor} !important` }}>
              🕒 Monday - Friday: 7:30 AM to 4:00 PM AEST<br />
              🚫 Saturday - Sunday: Closed
            </Typography>
            <Typography variant="body2" sx={{ mt: 2, fontStyle: 'italic' }}>
              Emergency after-hours support available for registered clients
            </Typography>
          </Box>
        </Paper>
  
        <Paper sx={{ 
          p: 4,
          backgroundColor: secondaryColor,
          borderRadius: 3,
          textAlign: 'center',
          alignItems: 'center',
          textColor: `${textColor} !important`
        }}>
          <Typography variant="body2" sx={{ color: `${textColor} !important` }}>
            © {new Date().getFullYear()} Sign Blast Pty Ltd<br />
            ABN: 81 620 074 553<br />
            All rights reserved | Privacy Policy | Terms of Service
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default Help;